module.exports = __webpack_public_path__ + "static/media/spacing.2fb5b41d.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Containers/spacing.md
// module id = 213
// module chunks = 0